import { render } from "./VideoUpload.vue?vue&type=template&id=5b80b0da&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"

import "./VideoUpload.vue?vue&type=style&index=0&id=5b80b0da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b80b0da"]])

export default __exports__